import React from 'react';
import { node, string, bool } from 'prop-types';
import { Tooltip } from '@fiverr-private/tooltip';
import { Container } from '@fiverr-private/layout_components';

const TooltipWrapper = (props) => {
    const { shouldRenderTooltip, children, className, ...rest } = props;

    if (!shouldRenderTooltip) {
        return children;
    }

    return (
        <Container className={className}>
            <Tooltip {...rest}>{children}</Tooltip>
        </Container>
    );
};

TooltipWrapper.propTypes = {
    children: node,
    className: string,
    content: node,
    appendToBody: bool,
    position: string,
    shouldRenderTooltip: bool,
};

export default TooltipWrapper;
